const state = {
  activeTheme: 'default',
  themes: {
    default: {
      name: 'Navy & Gold',
      description: 'Original professional theme'
    },
    purple: {
      name: 'Light Navy & Bright Gold',
      description: 'Softer variation'
    },
    slate: {
      name: 'Deep Navy & Warm Gold',
      description: 'Rich variation'
    },
    emerald: {
      name: 'Cool Navy & Soft Gold',
      description: 'Balanced variation'
    }
  }
}

const actions = {
  setTheme ({ commit }, themeName) {
    commit('setTheme', themeName)
    // Apply theme to root element
    document.documentElement.setAttribute('data-theme', themeName)
  }
}

const mutations = {
  setTheme (state, themeName) {
    state.activeTheme = themeName
  }
}

export const workspaceTheme = {
  namespaced: true,
  state,
  actions,
  mutations
}
